import React, { useRef, useLayoutEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  bubble: {
    pointerEvents: "none",
    userSelect: "none",
    opacity: 0
  },
  visibleBubble: {
    pointerEvents: "none",
    userSelect: "none",
    opacity: 0.8
  },
  background: {
    fill: "#333"
  },
  text: {
    pointerEvents: "none",
    userSelect: "none",
    fontSize: "10px",
    fill: theme.palette.common.white
  }
}));
const RadarBubble = (props) => {
  const classes = useStyles(props);
  const { visible, text } = props;
  const textElem = useRef(null);
  const svgElem = useRef(null);
  const rectElem = useRef(null);
  const pathElem = useRef(null);
  const updatePosition = () => {
    if (textElem.current) {
      const { x, y } = props;
      const bbox = textElem.current.getBBox();
      const marginX = 5;
      const marginY = 4;
      if (svgElem.current) {
        svgElem.current.setAttribute(
          "transform",
          `translate(${x - bbox.width / 2}, ${y - bbox.height - marginY})`
        );
      }
      if (rectElem.current) {
        rectElem.current.setAttribute("x", String(-marginX));
        rectElem.current.setAttribute("y", String(-bbox.height));
        rectElem.current.setAttribute(
          "width",
          String(bbox.width + 2 * marginX)
        );
        rectElem.current.setAttribute("height", String(bbox.height + marginY));
      }
      if (pathElem.current) {
        pathElem.current.setAttribute(
          "transform",
          `translate(${bbox.width / 2 - marginX}, ${marginY - 1})`
        );
      }
    }
  };
  useLayoutEffect(() => {
    updatePosition();
  });
  return /* @__PURE__ */ React.createElement(
    "g",
    {
      ref: svgElem,
      x: 0,
      y: 0,
      className: visible ? classes.visibleBubble : classes.bubble,
      "data-testid": "radar-bubble"
    },
    /* @__PURE__ */ React.createElement("rect", { ref: rectElem, rx: 4, ry: 4, className: classes.background }),
    /* @__PURE__ */ React.createElement("text", { ref: textElem, className: classes.text }, text),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        ref: pathElem,
        d: "M 0,0 10,0 5,8 z",
        className: classes.background
      }
    )
  );
};

export { RadarBubble as default };
//# sourceMappingURL=RadarBubble.esm.js.map
